export const GET_LOCATIONS_REQUEST = "GET_LOCATIONS_REQUEST";
export const GET_LOCATIONS_RESPONSE = "GET_LOCATIONS_RESPONSE";
export const DELETE_LOCATION_REQUEST = "DELETE_LOCATION_REQUEST";
